import ProgramesDestacats from './ProgramesDestacats';
import ProgramesDestacatsSkeleton from './ProgramesDestacats.skeleton';

export default function Component(props) {
    const { isLoading } = props;
    return isLoading ? <ProgramesDestacatsSkeleton {...props} /> : <ProgramesDestacats {...props} />;
}
